import { createSlice } from '@reduxjs/toolkit';

const profilesSlice = createSlice({
  name: 'profiles',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    setProfiles(state, action) {
      state.data = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
  },
});

export const { setProfiles, setLoading, setError } = profilesSlice.actions;
export default profilesSlice.reducer;
